var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-center" }, [
    _c(
      "p",
      [
        _vm._v(
          "\n    " + _vm._s(_vm.title) + ": " + _vm._s(_vm.rating) + "  \n    "
        ),
        _vm._l(Math.floor(_vm.rating), function(n) {
          return _c("b-icon", {
            key: "filled-" + n,
            attrs: {
              "font-scale": "1",
              variant: "primary",
              icon: "star-fill",
              "aria-hidden": "true"
            }
          })
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "star-empty-block" },
          _vm._l(5 - Math.floor(_vm.rating), function(n) {
            return _c("b-icon", {
              key: "empty-" + n,
              attrs: {
                "font-scale": "1",
                variant: "secondary",
                icon: "star",
                "aria-hidden": "true"
              }
            })
          }),
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14da0788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14da0788","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/RatingCustom.vue
// module id = 3044
// module chunks = 2 26